import script from "./FaceList.vue?vue&type=script&setup=true&lang=ts"
export * from "./FaceList.vue?vue&type=script&setup=true&lang=ts"

import "./FaceList.vue?vue&type=style&index=0&id=560997c2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-560997c2"]])

export default __exports__